import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Container, Jumbo, Separator } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import GoalsList from './GoalsList';
import NewGoalButton from './NewGoalButton';

const Background = styled(Container)`
	background: ${(props) => props.theme.colors.whiteBlue};
`;

export default function UserGoals(props: { userID: string }) {
	const { t } = useTranslation();

	const userQuery = graphql.useUserQuery({ variables: { id: props.userID } });

	const query = graphql.useIndividualGoalsQuery({
		variables: { id: props.userID, status: graphql.GoalStatus.Active, last: 10 },
		fetchPolicy: 'network-only',
	});
	const completedQuery = graphql.useIndividualGoalsQuery({
		variables: { id: props.userID, status: graphql.GoalStatus.Completed, last: 10 },
		fetchPolicy: 'network-only',
	});
	const archivedQuery = graphql.useIndividualGoalsLazyQuery({
		variables: { id: props.userID, status: graphql.GoalStatus.Archived, last: 10 },
		fetchPolicy: 'network-only',
	});

	return (
		<>
			<Jumbo
				alignItems="center"
				title={
					userQuery.data
						? t('individual.goals.index.title', {
								name: userQuery.data.user.firstName,
						  })
						: ''
				}
				button={<NewGoalButton userID={props.userID} />}
			/>
			<Separator />
			<Background py={4}>
				<GoalsList
					query={query}
					path="user.goalsV2"
					completedQuery={completedQuery}
					user={(query.data?.user ?? completedQuery.data?.user) as graphql.User}
					archivedQuery={archivedQuery}
					reorderable={false}
				/>
			</Background>
		</>
	);
}
